import React from 'react';
import bannerImg from './../../image/banner.jpg'
import { FaFacebook, FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
const Banner = () => {
    return (
        <div className="banner_item" style={{ backgroundImage: `url(${bannerImg})` }}>
            <div className="overlay" style={{ opacity: '1' }}>
                <div className="container">
                    <div className="row banner_content">
                        <h2><span>Hi! I am</span> Asaduzzaman</h2>
                        <h4>A Professional Web Developer</h4>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-0"></div>
                        <div className="col-lg-3 col-md-6">
                            <a className="banner_Btn " href="#con">
                                Contact
                            </a>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <a className="banner_Btn " href="https://drive.google.com/file/d/1HBBqd5CRohE9hJnadeJS8lozQSERBrCL/view?usp=sharing" target="blank" >
                                Download Resume
                            </a>
                        </div>
                        <div className="col-lg-3 col-md-0"></div>
                    </div>

                    <div className="row soc">
                        <ul>
                            <li> <a href="https://www.facebook.com/asaduzzaman.soumit.5"
                                style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='fb' target="blank"><FaFacebook style={{ fill: 'white' }} fontSize="24" /></a>
                            </li>
                            <li> <a href="https://www.instagram.com/asaduzzamansoumit/" className=" in" style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} target="blank"><FaInstagram style={{ fill: 'white' }} fontSize="24" /></a>
                            </li>
                            <li> <a href="https://www.linkedin.com/in/mohammad-asaduzzaman-5512441aa/"
                                style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='link' target="blank"><FaLinkedin style={{ fill: 'white' }} fontSize="24" /></a>
                            </li>
                            <li> <a href="https://github.com/asaduzzaman599"
                                style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='git' target="blank"><FaGithub style={{ fill: 'white' }} fontSize="24" /></a>
                            </li>
                        </ul>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Banner;